import { render } from "./DeleteAccount.vue?vue&type=template&id=1af73d48"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"

import "./DeleteAccount.vue?vue&type=style&index=0&id=1af73d48&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__